import React from 'react';
import { css } from '@emotion/core';
import TextFormSearch from 'components/molecules/TextFormSearch';

export type GlobalFilterProps = {
  state: any;
  setGlobalFilter: any;
  tableId?: number;
}

const style = css({
  border: 'none'
});


const GlobalFilter: React.FC<GlobalFilterProps> = ({ state, setGlobalFilter, tableId }) => (
  <div className="input-search">
    <TextFormSearch
      name="globalFilter"
      label=""
      css={css(style)}
      placeHolder="メンバーを検索"
      value={state.globalFilter || ''}
      onChange={(e) => {
        setGlobalFilter(e.target.value || undefined);
        sessionStorage.setItem(`${tableId}/sessionData${window.location.pathname}.globalFilterTxt`, e.target.value);
      }}
    />
  </div>
);
export default GlobalFilter;
